import { ProfileProgressInfoSnippet } from './InfoSnippet';
import { ProfileProgressPlaceHolderSnippet } from './PlaceHolderSnippet';

export const ProfileProgressSnippets = {
  Info: ProfileProgressInfoSnippet,
  PlaceHolder: ProfileProgressPlaceHolderSnippet,
};
